import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function EmotionalContext() {
  return <section id="emotional-context" className="py-20 md:py-32 bg-[#FAF7F2] text-[#0A0A0A]" data-id="element-35">
      <div className="max-w-4xl mx-auto px-4" data-id="element-36">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="text-4xl md:text-5xl font-serif text-[#0A0A0A] mb-8" data-id="element-38">
            La verdad sobre las relaciones largas
          </h2>
          <div className="text-xl md:text-2xl font-light leading-relaxed space-y-4 text-[#111111]/80" data-id="element-39">
            <p data-id="element-40">
              La mayoría de las relaciones no se terminan.{' '}
              <span className="font-medium text-[#0A0A0A]" data-id="element-41">Se enfrían.</span>
            </p>
            <p data-id="element-42">
              Y no por falta de amor. Sino porque la intimidad deja de
              profundizarse.
            </p>
            <p data-id="element-43">
              No es que ya no se amen.{' '}
              <span className="italic font-serif text-[#B91C1C]" data-id="element-44">
                Es que dejaron de encontrarse.
              </span>
            </p>
          </div>
        </motion.div>

        <motion.div className="bg-white p-8 md:p-10 rounded-sm shadow-xl border-l-4 border-[#C5A55A] mb-16" initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-45">
          <div className="flex items-center gap-3 mb-4" data-id="element-46">
            <Quote className="w-6 h-6 text-[#C5A55A] fill-current" data-id="element-47" />
            <h3 className="text-sm font-bold tracking-widest uppercase text-[#C5A55A]" data-id="element-48">
              Dato real — Psicología relacional
            </h3>
          </div>
          <p className="text-lg md:text-xl text-[#333] leading-relaxed" data-id="element-49">
            Estudios en terapia de pareja muestran que más del 70% de las crisis
            en relaciones largas no se deben a infidelidad ni a falta de amor,
            sino a{' '}
            <span className="font-semibold" data-id="element-50">
              desconexión emocional progresiva
            </span>{' '}
            y a la pérdida de espacios íntimos conscientes.
          </p>
        </motion.div>

        <motion.div className="text-center mb-16 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} data-id="element-51">
          <p className="text-lg text-[#555] mb-6" data-id="element-52">
            Y aquí el golpe emocional que casi nadie dice:
          </p>
          <h3 className="text-2xl md:text-3xl font-serif text-[#0A0A0A] leading-tight mb-6" data-id="element-53">
            El problema no es la rutina. <br data-id="element-54" />
            El problema es permitir que la rutina se adueñe de la relación.
          </h3>
          <p className="text-lg text-[#333] mb-6" data-id="element-55">
            Con los años, la relación cambia. El cuerpo cambia. La dinámica
            cambia.
          </p>
          <p className="text-xl font-serif italic text-[#B91C1C]" data-id="element-56">
            Pero lo que no debería cambiar… es la intimidad, la conexión, y el
            deseo de seguir eligiéndose.
          </p>
        </motion.div>

        <motion.div className="bg-[#0A0A0A] p-8 md:p-10 rounded-sm shadow-2xl border-r-4 border-[#C5A55A] text-[#FAF7F2]" initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-57">
          <div className="flex items-center gap-3 mb-4 justify-end" data-id="element-58">
            <h3 className="text-sm font-bold tracking-widest uppercase text-[#C5A55A]" data-id="element-59">
              Dato real — Neurociencia del vínculo
            </h3>
            <Quote className="w-6 h-6 text-[#C5A55A] fill-current transform scale-x-[-1]" data-id="element-60" />
          </div>
          <p className="text-lg md:text-xl text-[#FAF7F2]/90 leading-relaxed text-right" data-id="element-61">
            La intimidad profunda activa oxitocina y dopamina incluso en
            relaciones largas, cuando hay novedad emocional y presencia
            consciente, no cuando hay repetición automática.
          </p>
        </motion.div>

        <motion.div className="text-center mt-16" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} data-id="element-62">
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#0A0A0A]" data-id="element-63">
            No se trata de hacer más.{' '}
            <span className="text-[#B91C1C]" data-id="element-64">Se trata de sentirse más.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}